(() => {
  'use strict';

  const BRAND = 'FoodNet Express';
  const BRAND_RX = /\bWOKORA\b/gi;
  const SKIP = new Set(['SCRIPT','STYLE','NOSCRIPT','CODE','PRE','SVG']);
  const ATTRS = ['aria-label','aria-description','title','placeholder','alt'];

  const exact = new Map(Object.entries({
    'skip to content':'Ga naar inhoud','close':'Sluiten','menu':'Menu','search':'Zoeken','cart':'Winkelwagen','sign in':'Inloggen','main navigation':'Hoofdnavigatie','shop all':'Alle producten','language':'Taal','country':'Land',
    'previous':'Vorige','next':'Volgende','previous products':'Vorige producten','next products':'Volgende producten','view all':'Bekijk alles','view all results':'Bekijk alle resultaten','no results found':'Geen resultaten gevonden',
    'add to cart':'In winkelwagen','sold out':'Uitverkocht','unavailable':'Niet beschikbaar','quantity':'Aantal','choose options':'Kies opties','view product':'Bekijk product','origin':'Herkomst','storage advice':'Bewaaradvies','ingredients':'Ingrediënten','nutrition':'Voedingswaarden','brand':'Merk','product images':'Productafbeeldingen','decrease quantity':'Aantal verlagen','increase quantity':'Aantal verhogen','in stock':'Op voorraad','out of stock':'Niet op voorraad','packaging':'Verpakking','per unit':'Per stuk','per case':'Per doos','sale':'Aanbieding','new':'Nieuw','frozen':'Diepvries','fresh':'Vers','price':'Prijs','product type':'Producttype','allergens':'Allergenen',
    'your cart':'Winkelwagen','your cart is empty':'Je winkelwagen is leeg','continue shopping':'Verder winkelen','subtotal':'Subtotaal','checkout':'Afrekenen','remove':'Verwijderen','update cart':'Winkelwagen bijwerken','order note':'Bestelnotitie','view cart':'Bekijk winkelwagen','items':'artikelen','taxes and shipping are calculated at checkout.':'Belastingen en verzendkosten worden tijdens het afrekenen berekend.','shipping calculated at checkout.':'Verzendkosten worden bij het afrekenen berekend.','tax included.':'Inclusief btw.',
    'filter':'Filter','filters':'Filters','sort':'Sorteren','sort by':'Sorteren op','clear':'Wissen','clear all':'Alles wissen','apply':'Toepassen','active filters':'Actieve filters','from':'Van','to':'Tot','featured':'Aanbevolen','best selling':'Best verkocht','alphabetically, a-z':'Naam: A–Z','alphabetically, z-a':'Naam: Z–A','price, low to high':'Prijs: laag naar hoog','price, high to low':'Prijs: hoog naar laag','date, old to new':'Oudste eerst','date, new to old':'Nieuwste eerst',
    'email address':'E-mailadres','all rights reserved':'Alle rechten voorbehouden','breadcrumb':'Broodkruimelpad','collections':'Categorieën','collection':'Collectie','shop':'Assortiment','brands':'Merken','brand name':'Merknaam',
    'store password':'Winkelwachtwoord','enter store':'Winkel openen','powered by shopify':'Mogelijk gemaakt door Shopify',
    "we're preparing something delicious.":'We bereiden iets bijzonders voor.','our new asian grocery experience is coming soon.':'Onze nieuwe Aziatische winkelervaring komt binnenkort online.',
    'everything for your asian pantry':'Alles voor je Aziatische voorraadkast','use this section for delivery, sourcing, brand story or fresh and frozen shopping information.':'Gebruik dit onderdeel voor informatie over levering, herkomst, ons merk en verse of diepvriesproducten.','learn more':'Meer informatie',
    'amazing deals':'Scherpe aanbiedingen',"discover, shop and save on this week's picks.":'Ontdek onze geselecteerde aanbiedingen van deze week.','example asian product':'Voorbeeld Aziatisch product',
    'shop the names you know and love.':'Bekijk de merken die je kent en graag gebruikt.','popular recipes':'Populaire recepten','turn authentic ingredients into something delicious.':'Maak met authentieke ingrediënten iets heerlijks.','view all recipes':'Bekijk alle recepten','view recipe →':'Bekijk recept →','view recipe':'Bekijk recept','gyoza bowl with fresh vegetables':'Gyoza-bowl met verse groenten','20 minutes':'20 minuten','easy':'Makkelijk',
    'authentic asian groceries, made easy.':'Authentieke Aziatische producten, eenvoudig besteld.','build a clear value proposition with merchant-editable content and no hard-coded storefront copy.':'Presenteer je aanbod helder met eenvoudig aanpasbare inhoud.','shop now':'Nu winkelen',
    'fast delivery':'Snelle levering','reliable shipping across selected eu markets.':'Betrouwbare verzending binnen geselecteerde EU-markten.',
    "we couldn't find that page.":'Deze pagina konden we niet vinden.','back to home':'Terug naar home','delivery area around bruges, belgium':'Bezorggebied rond Brugge, België',
    'customer account':'Klantaccount','activate account':'Account activeren','reset password':'Wachtwoord herstellen','product recommendations':'Productaanbevelingen','recently viewed':'Recent bekeken','newsletter':'Nieuwsbrief','announcement bar':'Meldingsbalk'
  }));

  function translate(raw) {
    if (typeof raw !== 'string' || !raw) return raw;
    let value = raw.replace(BRAND_RX, BRAND);
    const leading = (value.match(/^\s*/) || [''])[0];
    const trailing = (value.match(/\s*$/) || [''])[0];
    const core = value.trim();
    const mapped = exact.get(core.toLocaleLowerCase('en'));
    return mapped ? `${leading}${mapped}${trailing}` : value;
  }

  function fixText(node) {
    if (!node || node.nodeType !== Node.TEXT_NODE || !node.parentElement || SKIP.has(node.parentElement.tagName)) return;
    const next = translate(node.nodeValue);
    if (next !== node.nodeValue) node.nodeValue = next;
  }

  function fixAttributes(el) {
    if (!(el instanceof Element) || SKIP.has(el.tagName)) return;
    for (const attr of ATTRS) {
      if (!el.hasAttribute(attr)) continue;
      const current = el.getAttribute(attr) || '';
      const next = translate(current);
      if (next !== current) el.setAttribute(attr, next);
    }
    if (el instanceof HTMLInputElement) {
      if (/^(submit|button|reset)$/.test(el.type)) {
        const next = translate(el.value);
        if (next !== el.value) el.value = next;
      } else if (BRAND_RX.test(el.value || '')) {
        BRAND_RX.lastIndex = 0;
        el.value = String(el.value || '').replace(BRAND_RX, BRAND);
      }
      BRAND_RX.lastIndex = 0;
    }
  }

  function fixElement(el) {
    if (!(el instanceof Element) || SKIP.has(el.tagName)) return;
    fixAttributes(el);
    for (const child of el.childNodes) {
      if (child.nodeType === Node.TEXT_NODE) fixText(child);
      else if (child.nodeType === Node.ELEMENT_NODE) fixElement(child);
    }
  }

  function fixJsonLd(root = document) {
    root.querySelectorAll?.('script[type="application/ld+json"]').forEach((script) => {
      const current = String(script.textContent || '');
      const next = current.replace(BRAND_RX, BRAND);
      if (next !== current) script.textContent = next;
    });
  }

  function apply(root = document.body) {
    if (!root) return;
    if (root.nodeType === Node.TEXT_NODE) fixText(root);
    else if (root.nodeType === Node.ELEMENT_NODE) fixElement(root);
  }

  function containsJsonLd(node) {
    return node instanceof Element && (
      node.matches('script[type="application/ld+json"]') ||
      !!node.querySelector('script[type="application/ld+json"]')
    );
  }

  const pendingRoots = new Set();
  let pendingFrame = 0;
  let pendingJsonLd = false;

  function flushPending() {
    pendingFrame = 0;
    const roots = Array.from(pendingRoots);
    pendingRoots.clear();
    const shouldFixJsonLd = pendingJsonLd;
    pendingJsonLd = false;
    roots.forEach(apply);
    if (shouldFixJsonLd) fixJsonLd(document);
  }

  function scheduleFlush() {
    if (pendingFrame) return;
    if (typeof window.requestAnimationFrame === 'function') pendingFrame = window.requestAnimationFrame(flushPending);
    else pendingFrame = window.setTimeout(flushPending, 16);
  }

  function queueApply(node) {
    if (!node || (node.nodeType !== Node.TEXT_NODE && node.nodeType !== Node.ELEMENT_NODE)) return;

    const jsonRoot = node instanceof Element ? node : node.parentElement;
    if (containsJsonLd(jsonRoot)) pendingJsonLd = true;

    for (const existing of Array.from(pendingRoots)) {
      if (existing === node) return;
      if (existing instanceof Element && existing.contains(node)) return;
      if (node instanceof Element && node.contains(existing)) pendingRoots.delete(existing);
    }

    pendingRoots.add(node);
    scheduleFlush();
  }

  function eventRoot(event) {
    return event?.detail?.root instanceof Element ? event.detail.root : event?.target;
  }

  function boot() {
    document.documentElement.setAttribute('lang','nl-BE');
    const nextTitle = translate(document.title);
    if (nextTitle !== document.title) document.title = nextTitle;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      const next = translate(meta.getAttribute('content') || '');
      if (next !== meta.getAttribute('content')) meta.setAttribute('content', next);
    }
    apply(document.body);
    fixJsonLd(document);

    const observer = new MutationObserver((records) => {
      for (const record of records) {
        for (const node of record.addedNodes || []) queueApply(node);
      }
    });
    observer.observe(document.body, { childList:true, subtree:true });

    document.addEventListener('shopify:section:load', (event) => queueApply(event.target));
    document.addEventListener('wokora:content-updated', (event) => queueApply(eventRoot(event)));
    document.addEventListener('wokora:cart-drawer-refreshed', (event) => queueApply(eventRoot(event)));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once:true });
  else boot();
})();
